import {
  PAEventType,
  ProductAnalyticsEvent,
  ToggledEvents
} from '@dadohr/shared/domainTypes/productAnalytics';
import { IReportActor } from '@dadohr/shared/domainTypes/reports';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { capitalize } from 'lodash';
import { WithShape } from '../../../../components/Charts/Util';
import { FlexContainer } from '../../../../layout/Flex';
import { useProductAnalytics } from '../../../../services/productAnalytics';

type TrackingInfo = {
  name: ToggledEvents;
  explanation: string;
};

export type TrackingKey =
  | 'Completion per cohort'
  | 'Completion per tasks'
  | 'Tasks by status';
const TRACKING_INFO: Record<TrackingKey, TrackingInfo> = {
  'Completion per cohort': {
    name: 'Completion Per Cohort Chart Toggled',
    explanation:
      'Admin user changed the actor settings for the heat map showing completion rate per task and per cohort'
  },
  'Completion per tasks': {
    name: 'Completion Per Tasks Chart Toggled',
    explanation:
      'Admin user changed the actor settings for the bar chart showing completion rate per task'
  },
  'Tasks by status': {
    name: 'Tasks By Status Chart Toggled',
    explanation:
      'Admin user changed the actor for the stacked bar chart showing tasks by status'
  }
};

const trackToggleChange = (
  trackEvent: (ev: ProductAnalyticsEvent) => Promise<void>,
  trackingKey: TrackingKey,
  activeToggles: string[]
) => {
  const info = TRACKING_INFO[trackingKey];
  if (!info) {
    return;
  }

  trackEvent({
    eventType: PAEventType.OTHER,
    name: info.name,
    Explanation: info.explanation,
    'Toggle Changed': 'Actors',
    'New Toggle Value': activeToggles.map(capitalize).join(', ')
  });
};

export const ActorSelector = ({
  actors,
  selected: value,
  setSelected: onChange,
  marginBottom = 2,
  trackingKey
}: {
  actors: IReportActor[];
  selected: string[]; // actorKey[]
  setSelected: (nextActors: string[]) => void;
  marginBottom?: number; // spacing multiplier
  trackingKey: TrackingKey;
}) => {
  const { trackEvent } = useProductAnalytics();

  return (
    <FlexContainer marginBottom={marginBottom} spacing={4} wrap="wrap">
      {actors.map((actor) => {
        const isSelected = value.includes(actor.key);
        return (
          <FormControlLabel
            key={actor.key}
            control={
              <Checkbox
                checked={isSelected}
                name={actor.key}
                onChange={() => {
                  const nextValue = isSelected
                    ? value.filter((x) => x !== actor.key)
                    : [...value, actor.key];
                  onChange(nextValue);
                  trackToggleChange(trackEvent, trackingKey, nextValue);
                }}
              />
            }
            label={<WithShape color={actor.color}>{actor.label}</WithShape>}
          />
        );
      })}
    </FlexContainer>
  );
};
